/**
 * TermsOfService - Termos de Uso da plataforma HeveaTalent
 */
import React from "react";
import { useTranslation } from "../translations";
import { ArrowLeft } from "lucide-react";

const TermsOfService = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <header className="bg-green-800 text-white py-8">
        <div className="container mx-auto px-4">
          <a href="/" className="inline-flex items-center gap-2 text-green-200 hover:text-white mb-4 text-sm">
            <ArrowLeft className="w-4 h-4" /> HeveaTalent
          </a>
          <h1 className="text-3xl font-bold">{t('termsTitle')}</h1>
          <p className="text-green-200 mt-2">{t('lastUpdated')}: 17/03/2026</p>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
          
          <section>
            <h2 className="text-2xl font-bold text-gray-900">1. Aceitação dos Termos</h2>
            <p>Ao acessar e utilizar a plataforma HeveaTalent ("Plataforma"), você concorda com estes Termos de Uso. A HeveaTalent é uma plataforma digital voltada para a gestão de desempenho na heveicultura, conectando proprietários rurais e profissionais sangria de seringueiras.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">2. Descrição do Serviço</h2>
            <p>A HeveaTalent oferece:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Calendário de sangria com registro diário de produção</li>
              <li>Sistema de avaliação e selos de qualidade profissional</li>
              <li>Relatórios de desempenho e produtividade</li>
              <li>Marketplace para conexão entre profissionais e proprietários</li>
              <li>Comunidade para compartilhamento de conhecimento</li>
              <li>Gestão de equipes e propriedades rurais</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">3. Cadastro e Conta</h2>
            <p>Para utilizar a Plataforma, o usuário deve criar uma conta fornecendo informações verdadeiras e atualizadas. O usuário é responsável por manter a confidencialidade de sua senha e por todas as atividades realizadas em sua conta.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">4. Planos e Pagamentos</h2>
            <p>A Plataforma oferece planos gratuitos e pagos. Os pagamentos são processados via Stripe, uma plataforma de pagamentos segura e internacionalmente reconhecida. Aceitamos cartão de crédito, débito e PIX.</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Os preços estão expressos em Reais (BRL) ou Dólares (USD)</li>
              <li>Assinaturas mensais podem ser canceladas a qualquer momento</li>
              <li>O cancelamento mantém o acesso ativo até o final do período pago</li>
              <li>Não há reembolso proporcional para períodos parciais</li>
              <li>Planos anuais oferecem desconto sobre o valor mensal</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">5. Conduta do Usuário</h2>
            <p>O usuário se compromete a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fornecer informações verdadeiras e precisas</li>
              <li>Não utilizar a Plataforma para fins ilegais</li>
              <li>Respeitar outros usuários da comunidade</li>
              <li>Não manipular avaliações ou selos de qualidade</li>
              <li>Não compartilhar conteúdo ofensivo ou inadequado</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">6. Propriedade Intelectual</h2>
            <p>Todo o conteúdo da Plataforma, incluindo textos, gráficos, logos, ícones, imagens e software, é propriedade da HeveaTalent ou de seus licenciadores e está protegido por leis de propriedade intelectual.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">7. Limitação de Responsabilidade</h2>
            <p>A HeveaTalent não se responsabiliza por:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Decisões tomadas com base nos dados da plataforma</li>
              <li>Perdas de produção ou lucros cessantes</li>
              <li>Interrupções temporárias do serviço por manutenção</li>
              <li>Condutas de outros usuários na comunidade ou marketplace</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">8. Alterações nos Termos</h2>
            <p>A HeveaTalent pode alterar estes Termos a qualquer momento. As alterações entram em vigor após publicação na Plataforma. O uso continuado após alterações constitui aceitação dos novos termos.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900">9. Contato</h2>
            <p>Para dúvidas sobre estes Termos de Uso:</p>
            <p className="font-semibold">Email: heveatalent@gmail.com</p>
          </section>

        </div>
      </main>

      <footer className="py-8 bg-gray-900">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center gap-6 text-sm text-gray-400 mb-3">
            <a href="/proposito" className="hover:text-green-400 transition-colors">HeveaTalent</a>
            <a href="/privacidade" className="hover:text-green-400 transition-colors">{t('privacyTitle') || 'Política de Privacidade'}</a>
          </div>
          <p className="text-gray-500 text-xs">© 2025-2026 HeveaTalent</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
